import React from 'react'

export default function Separator() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2 32" height="32" width="2" fill="var(--color-border-subtle, #ffffff50)">
            <path d="M0 0h2v32H0z"></path>
        </svg>
    )
}
